import { __decorate } from "tslib";
// Core
import { Component, Mixins } from 'vue-property-decorator';
// Extends
import AlertMixin from '@/helpers/vue_mixins/AlertMixin';
import ButtonLoadingMixin from '@/helpers/vue_mixins/ButtonLoaderMixin';
// Children
// Models / Helpers
// Queries / Mutations
import UpdatePromptAction from '@/plugins/graphql/mutations/v3/prompts/update-prompt-action.gql';
/**
 * Prompt status updater
 * @author Jan Canicon <jan@gorated.ph>
 * @since Version {x.x.x}
 */
let PromptUpdaterMixin = class PromptUpdaterMixin extends Mixins(AlertMixin, ButtonLoadingMixin) {
    updateAction(promptUUID, status) {
        this.requestOnFlight();
        return this.$apollo
            .mutate({
            mutation: UpdatePromptAction,
            variables: {
                input: {
                    promptUuid: promptUUID,
                    status,
                },
            },
        })
            .then(() => {
            this.requestDone();
        })
            .catch((e) => {
            this.errorNotification(e.message);
        });
    }
};
PromptUpdaterMixin = __decorate([
    Component
], PromptUpdaterMixin);
export default PromptUpdaterMixin;
